// extracted by mini-css-extract-plugin
module.exports = {"container":"Dropzone_container__vAlRe","isDragActive":"Dropzone_isDragActive__12-DA","browse":"Dropzone_browse__2_scN"};